import NavBar from "./NavBar";
import Bureau from "../Assets/pexels-karolina-grabowska-large.jpg";
import Divider from "@mui/material/Divider";
import Sophie from "../Assets/IMG20230614165205.jpg";
import Therapie from "../Assets/therapie.png";
import Sophro from "../Assets/Sophro.png";
import Hypnotherapie from "../Assets/hypnotherapie.png";
import { useNavigate } from "react-router-dom";
import Footer from "./Multi_Component/Footer";

const Home = () => {
  const navigate = useNavigate();
  return (
    <>
      <NavBar />

      <div className="containerImgSophieDesk">
        <img className="sophieDesk" src={Bureau} alt="bureauSophie" />
        <div className="textSophieDesk">
          <div className="divSophieDesk">
            <span>Thérapeute,</span> <span>Sophrologue,</span>{" "}
            <span>Hypnothérapeute</span> à Paray-Vieille-Poste
          </div>
          <div className="divider">
            <Divider
              variant="middle"
              width="100px"
              style={{
                borderColor: "#CB997E",
                borderRadius: "10px",
                marginBottom: "30px",
              }}
            />
          </div>
          <div className="divSophieDeskSecond">
            <span>{`"Le bonheur c'est du bien être dont on prend conscience" (Christophe André)`}</span>
          </div>
        </div>
      </div>
      <div className="profilecontentframeHome">
        <div className="homeWelcomeSection">
          <h2 className="homeWelcomeTitle">
            <span className="homeWelcomeAccent">Bienvenue sur le chemin du mieux-être</span>
          </h2>
          <div className="homeDivider">
            <Divider
              variant="middle"
              style={{
                borderColor: "#CB997E",
                borderRadius: "10px",
                maxWidth: "80px",
              }}
            />
          </div>
        </div>
        <div className="homeProfileSection">
          <div className="homeProfileContent">
            <img
              src={Sophie}
              alt="Sophie Mele"
              className="homeProfileImage"
            />
            <div className="homeProfileText">
              <p>
                Je suis Sophie Mele, Thérapeute certifié en Hypnose Sajece,
                Sophrologie Caycedienne et psycho-praticienne spécialisé enfants et
                adolescents.
              </p>
              <p>
                J'ai à coeur de vous accompagner dans vos libérations d'émotions et
                de vous aider à retrouver espoir, confiance et bienveillance envers
                vous-même.
              </p>
              <p>
                Mon mantra depuis toujours est la <span className="homeAccentText">PURA VIDA</span>, qui signifie vie pure.
                Chacun possède sa propre définition d'une vie pure, d'une vie
                heureuse, d'une vie épanouissante.
              </p>
              <p>
                Mon travail est de vous aider à trouver votre propre chemin du
                bonheur, votre chemin de la guérison et du bien être. Votre <span className="homeAccentText">PURA VIDA</span> à vous !
              </p>
              <p>
                J'expérimente moi même ce travail depuis plusieurs années et je suis
                convaincue des bienfaits des thérapies de libération par la parole,
                par la sophrologie et par l'hypnose.
              </p>
              <p>
                Après plusieurs années dans le secteur bancaire, j'ai souhaité me
                former aux différentes techniques thérapeutique afin de pouvoir, à
                mon tour, aider et accompagner.
              </p>
            </div>
          </div>
        </div>
        <div className="homeSeancesSection">
          <div className="homeDivider">
            <Divider
              variant="middle"
              style={{
                borderColor: "#CB997E",
                borderRadius: "10px",
                maxWidth: "80px",
              }}
            />
          </div>
          <h2 className="homeSectionTitle">
            Les séances
          </h2>
          <div className="homeDivider">
            <Divider
              variant="middle"
              style={{
                borderColor: "#CB997E",
                borderRadius: "10px",
                maxWidth: "80px",
              }}
            />
          </div>
      
          <div className="homeSeancesGrid">
            <button
              className="homeSeanceCard"
              onClick={() => {navigate("/therapie");window.scrollTo(0, 0); }}
            >
              <img
                src={Therapie}
                className="homeSeanceCardImage"
                alt="Thérapie"
              />
            </button>
            <button
              className="homeSeanceCard"
              onClick={() => {navigate("/sophrologie");window.scrollTo(0, 0)}}
            >
              <img
                src={Sophro}
                className="homeSeanceCardImage"
                alt="Sophrologie"
              />
            </button>
            <button
              className="homeSeanceCard"
              onClick={() => {navigate("/hypnotherapie");window.scrollTo(0, 0)}}
            >
              <img
                src={Hypnotherapie}
                className="homeSeanceCardImage"
                alt="Hypnothérapie"
              />
            </button>
          </div>
         
          <div className="homeCTAWrapper">
            <button className="homeCTAButton" onClick={() => navigate("/rdvlist")}>
              PRENDRE RDV
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
